import React, { useState } from 'react';
import { ArrowUpward } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import { Box } from "@mui/material";
import useStyles from '../../../assets/styles/ChatBotStyles';
import {CHAT_TYPE} from "../../../utils/constants";

const parseMarkdown = (text) => {
    if (!text) return '';

    // Replace ** for bold
    let formatted = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    // Replace * or _ for italics
    formatted = formatted.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');

    // Replace ``` for code blocks
    formatted = formatted.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');

    // Replace ` for inline code
    formatted = formatted.replace(/`([^`]+)`/g, '<code>$1</code>');

    // Replace --- or *** for horizontal rule
    formatted = formatted.replace(/^(\-{3,}|\*{3,})$/gm, '<hr>');

    // Replace # headers
    formatted = formatted.replace(/^(#{1,6})\s+(.*?)$/gm, (match, hashes, content) => {
        const level = hashes.length;
        return `<h${level}>${content}</h${level}>`;
    });

    // Replace > for blockquotes
    formatted = formatted.replace(/^>\s+(.*?)$/gm, '<blockquote>$1</blockquote>');

    // Replace numbered lists (1. First item)
    formatted = formatted.replace(/^\d+\.\s+(.*?)$/gm, '<li>$1</li>');

    // Replace bullet lists (- Item or * Item)
    formatted = formatted.replace(/^[\-\*]\s+(.*?)$/gm, '<li>$1</li>');

    // Wrap adjacent list items in <ul> or <ol> tags
    formatted = formatted.replace(/<li>.*?<\/li>/gs, match => {
        if (match.includes('</li><li>')) {
            return `<ul>${match}</ul>`;
        }
        return match;
    });

    // Handle line breaks
    formatted = formatted.replace(/\n/g, '<br>');

    return formatted;
};

const ChatBot = ({
                     chatHistory,
                     input,
                     onInputChange,
                     onInputKeyDown,
                     onSendClick,
                     showChat,
                     isBotThinking
                 }) => {
    const classes = useStyles();

    const height = showChat ? '65vh' : '0';
    
    return (
        <Box className={classes.container} style={{ bottom: '6%' }}>
            <div
                style={{
                    height,
                    overflowY: 'auto',
                    padding: showChat ? '10px' : '0',
                    borderRadius: '10px',
                    transition: 'all 0.3s ease',
                }}
            >
                {chatHistory.map((chat, index) =>
                    chat.type === CHAT_TYPE.USER ? (
                        <div key={index} style={{ textAlign: 'right', marginBottom: '10px' }}>
                            <div
                                style={{
                                    backgroundColor: '#F2CB91',
                                    display: 'inline-block',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    maxWidth: '80%',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}
                            >
                                <div>{chat.text}</div>
                            </div>
                        </div>
                    ) : (
                        <div key={index} style={{ textAlign: 'left', marginBottom: '10px', padding: '0 10px' }}>
                            <div
                                style={{
                                    backgroundColor: 'transparent',
                                    padding: '10px',
                                    borderRadius: '8px',
                                    maxWidth: '100%',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}
                                dangerouslySetInnerHTML={{ __html: parseMarkdown(chat.text) }}
                            />
                        </div>
                    )
                )}
                {isBotThinking && (
                    <div style={{ textAlign: 'left', margin: '10px 0', color: '#aaa', fontStyle: 'italic' }}>
                        Bot is thinking...
                    </div>
                )}
            </div>

            <Box className={classes.inputWrapper} sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                width: '100%'
            }}>
                <TextField
                    value={input}
                    multiline
                    onChange={onInputChange}
                    onKeyDown={onInputKeyDown}
                    disabled={isBotThinking}
                    placeholder="Type your message..."
                    variant="outlined"
                    fullWidth
                    className={classes.inputField}
                    InputProps={{
                        endAdornment: (
                            <IconButton
                                className={classes.iconButton}
                                onClick={onSendClick}
                            >
                                <ArrowUpward />
                            </IconButton>
                        ),
                    }}
                />
            </Box>
        </Box>
    );
};

export default ChatBot;